(function () {
  var WORKER_CONFIG = 'https://fusmatten-admin.totulonline-shop.workers.dev/api/public/config.json';
  var THEME_CONFIG = window.__FUSMATTEN_CONFIG_URL__ || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root + 'assets/fusmatten-runtime-config.json'
    : '/assets/fusmatten-runtime-config.json');

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function brandSlug(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function rewriteLegacyBrandFilter() {
    try {
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var legacy = params.getAll('filter.p.m.custom.fahrzeugmarke');
      var brand = params.get('filter.p.m.custom.marke') || legacy[0] || '';
      var model = params.get('filter.p.m.custom.fahrzeugmodell');
      var year = params.get('filter.p.m.custom.Baujahr');
      var path = (url.pathname || '').replace(/\/+$/, '') || '/';

      if (path === '/collections/all' && brand && !model && !year && window.__FUSMATTEN_BRANDS_URL__) {
        fetchJson(window.__FUSMATTEN_BRANDS_URL__).then(function (list) {
          if (!Array.isArray(list)) return;
          var wanted = String(brand).toLowerCase().trim();
          var slug = brandSlug(brand);
          var match = list.filter(function (entry) {
            return entry && (
              String(entry.name || '').toLowerCase() === wanted ||
              String(entry.slug || '') === slug
            );
          })[0];
          if (match && match.collection) {
            window.location.replace('/collections/' + encodeURIComponent(match.collection));
          }
        });
      }

      if (!legacy.length) return false;
      params.delete('filter.p.m.custom.fahrzeugmarke');
      legacy.forEach(function (value) {
        if (!value) return;
        if (params.getAll('filter.p.m.custom.marke').indexOf(value) === -1) {
          params.append('filter.p.m.custom.marke', value);
        }
      });
      if (path === '/collections/all' && brand && !model && !year) return false;
      var next = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
      window.location.replace(next);
      return true;
    } catch (e) {
      return false;
    }
  }

  function loadConfig() {
    rewriteLegacyBrandFilter();
    return fetchJson(WORKER_CONFIG + (WORKER_CONFIG.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now()).then(function (cfg) {
      if (cfg && typeof cfg === 'object') return cfg;
      return fetchJson(THEME_CONFIG);
    });
  }

  function walkTextNodes(root, visitor) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) visitor(node);
  }

  function germanizeDiscountText(value, replacement) {
    if (!value || value.length > 80) return value;
    if (!/indirim/i.test(value)) return value;
    var next = value;
    next = next.replace(/%\s*\d+\s*indirim/gi, replacement);
    next = next.replace(/\d+\s*%\s*indirim/gi, replacement);
    next = next.replace(/indirim/gi, 'Rabatt');
    return next;
  }

  function applyDiscountBannerText(config) {
    if (!config || !config.discountBanner || config.discountBanner.enabled === false) return;
    var text = config.discountBanner.text_de || '5% Rabatt';
    walkTextNodes(document.body, function (node) {
      var parent = node.parentElement;
      if (parent && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE|PRE)$/i.test(parent.tagName)) return;
      var value = node.nodeValue || '';
      if (!/indirim/i.test(value)) return;
      var next = germanizeDiscountText(value, text);
      if (next !== value) node.nodeValue = next;
    });
    document.querySelectorAll('[placeholder], [aria-label], [title], [alt]').forEach(function (el) {
      ['placeholder', 'aria-label', 'title', 'alt'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (!value) return;
        var next = germanizeDiscountText(value, text);
        if (next !== value) el.setAttribute(attr, next);
      });
    });
    germanizeFormsEmbeds(text);
  }

  // Shopify Forms renders its teaser inside (nested) open shadow roots and adds it after the popup closes.
  function germanizeShadowTree(root, text) {
    walkTextNodes(root, function (node) {
      var value = node.nodeValue || '';
      if (!/indirim/i.test(value)) return;
      var next = germanizeDiscountText(value, text);
      if (next !== value) node.nodeValue = next;
    });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) watchShadowRoot(el.shadowRoot, text);
    });
  }

  function watchShadowRoot(root, text) {
    if (root.__fmGermanized) return;
    root.__fmGermanized = true;
    germanizeShadowTree(root, text);
    new MutationObserver(function () { germanizeShadowTree(root, text); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  function germanizeFormsEmbeds(text) {
    function scan() {
      document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
        if (host.shadowRoot) watchShadowRoot(host.shadowRoot, text);
      });
    }
    scan();
    // The embed attaches its shadow root lazily; retry briefly until it exists.
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries >= 20) clearInterval(timer);
    }, 500);
  }

  function applyImageUrl(img, url) {
    if (!img || !url) return;
    img.setAttribute('src', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  }

  function applyBeforeAfter(config) {
    if (!config || !config.beforeAfter) return;
    var before = config.beforeAfter.beforeUrl;
    var after = config.beforeAfter.afterUrl;
    if (!before && !after) return;
    document.querySelectorAll('[id^="BeforeAfterSplit-"], .ba-split-section').forEach(function (section) {
      var beforeImg = section.querySelector('.ba-img-before, [data-ba-role="before"]');
      var afterImg = section.querySelector('.ba-img-after, [data-ba-role="after"]');
      if (before) applyImageUrl(beforeImg, before);
      if (after) applyImageUrl(afterImg, after);
    });
  }

  function wireCollectionFilterTabs() {
    /* Product type tabs are rendered in Liquid (Alle / 5D / 3D). */
  }

  function sortCollectionGrid() {
    if (!window.FusmattenSearchSort) return;
    var grid = document.getElementById('AdvProductGrid');
    if (grid) FusmattenSearchSort.sortDomCards(grid, ':scope > .fusmatten-product-card, :scope > a.fusmatten-product-card, :scope > *');
    var results = document.querySelector('.product-grid');
    if (results) {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q') || '';
      if (q) FusmattenSearchSort.applyTitleFilterToCards(results, '.product-grid__item', q);
      else FusmattenSearchSort.sortDomCards(results, '.product-grid__item');
    }
  }

  function publishConfig(config) {
    if (!config) return;
    window.FusmattenRuntimeConfig = config;
    document.dispatchEvent(new CustomEvent('fusmatten:config-ready', { detail: config }));
  }

  function boot(config) {
    publishConfig(config);
    applyDiscountBannerText(config);
    applyBeforeAfter(config);
    wireCollectionFilterTabs();
    sortCollectionGrid();
  }

  document.addEventListener('DOMContentLoaded', function () {
    wireCollectionFilterTabs();
    sortCollectionGrid();
    loadConfig().then(boot);
    if (window.MutationObserver) {
      var timer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          applyDiscountBannerText(window.FusmattenRuntimeConfig || { discountBanner: { text_de: '5% Rabatt', enabled: true } });
        }, 250);
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  });
})();
